var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.67095 23.3438C7.25065 23.3438 9.3419 21.2521 9.3419 18.6719C9.3419 16.0917 7.25065 14 4.67095 14C2.09126 14 0 16.0917 0 18.6719C0 21.2521 2.09126 23.3438 4.67095 23.3438Z",
    fill: "#0D1833"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6839 23.3438C21.2636 23.3438 23.3548 21.2521 23.3548 18.6719C23.3548 16.0917 21.2636 14 18.6839 14C16.1042 14 14.0129 16.0917 14.0129 18.6719C14.0129 21.2521 16.1042 23.3438 18.6839 23.3438Z",
    fill: "#0D1833"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6968 23.3438C35.2765 23.3438 37.3678 21.2521 37.3678 18.6719C37.3678 16.0917 35.2765 14 32.6968 14C30.1171 14 28.0259 16.0917 28.0259 18.6719C28.0259 21.2521 30.1171 23.3438 32.6968 23.3438Z",
    fill: "#0D1833"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHMenu);
export default __webpack_public_path__ + "static/media/h-menu.19e97623c6c6358601d7663704811728.svg";
export { ForwardRef as ReactComponent };